import { render, staticRenderFns } from "./ImportClients.vue?vue&type=template&id=5059c1c9&scoped=true"
import script from "./ImportClients.vue?vue&type=script&lang=js"
export * from "./ImportClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5059c1c9",
  null
  
)

export default component.exports